import { SESSION_COOKIE_NAME } from '@/constants/settings';
import { getCookie } from '@/ducks/cookies';

export const getVWOUserId = () => getCookie(SESSION_COOKIE_NAME);
